import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { Listing, IgnoreSessionAddEdit } from './Pages';

export const IgnoreSessionRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={Listing} />
        <Route exact path = {`${match.path}/addEdit`} component={IgnoreSessionAddEdit} />
    </Fragment>
)